import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import browserHistory from 'react-router/lib/browserHistory';
import cx from 'classnames';

// styles
import * as styles from './RealtorLandingContactForm.scss';

import InputField from '../../components/Company/CompanyContactUs/CompanyField/CompanyField';
import { required } from '../../helpers/reduxFormValidators';
import OMButtonWithPreloader from '../../components/OMComponents/OMButtonWithPreloader/OMButtonWithPreloader';
import OMTextArea from '../../components/OMComponents/OMTextArea/OMTextArea';
import OMMultiCheckbox from '../../components/OMComponents/OMMultiCheckbox/OMMultiCheckbox';
import CloudflareCaptcha from '../../components/CloudflareCaptcha/CloudflareCaptcha';

import appendLocale from '../../helpers/appendLocale';
import CAPTCHA_ACTIONS from '../../helpers/captchaConstants';

class RealtorLandingContactFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sending: false,
      params: {},
      captcha: null,
      showCaptcha: false
    };
  }

  componentWillReceiveProps({ contactUs, isMessageModalOpen }) {
    const stateModifier = {};
    const translate = this.props.translate('contactUsPage');

    if (contactUs.loading !== this.props.contactUs.loading) {
      stateModifier.sending = contactUs.loading;
    }

    if (contactUs.loaded && contactUs.loaded !== this.props.contactUs.loaded && this.state.params.email) {
      this.props.openMessageModal({
        message: (
          <div className={styles.contentMessageWrapper}>
            <div className={styles.contentMessage}>
              <p className={styles.title}>
                {translate('modalFeedback', 'title')}
              </p>
              <div>
                <p>
                  {translate('modalFeedback', 'weWillContact')}
                </p>
                <p>
                  {translate('modalFeedback', 'messageNotification')}
                </p>
              </div>
              <button
                className={styles.primary}
                onClick={this.props.hideMessageModal}
              >
                {translate('modalFeedback', 'textButton')}
              </button>
            </div>
          </div>
        ),
        isCloseButtonInvisible: true
      });

      this.props.handleRequest && this.props.handleRequest();
    }

    if (contactUs.loaded && contactUs.loaded !== this.props.contactUs.loaded && !this.state.params.email) {
      this.props.openMessageModal({
        message: (
          <div className={styles.contentMessageWrapper}>
            <div className={styles.contentMessage}>
              <p className={styles.title}>
                {translate('modalFeedback', 'title')}
              </p>
              <div>
                <p>
                  {translate('modalFeedback', 'weWillContact')}
                </p>
                <p>
                  {translate('modalFeedback', 'notificationWithoutMessage')}
                </p>
              </div>
              <button
                className={styles.primary}
                onClick={this.props.hideMessageModal}
              >
                {translate('modalFeedback', 'textButton')}
              </button>
            </div>
          </div>
        ),
        isCloseButtonInvisible: true
      });

      this.props.handleRequest && this.props.handleRequest();
    }

    if (contactUs.error && contactUs.error !== this.props.contactUs.error) {
      this.props.openMessageModal({
        message: (
          <div className={styles.contentMessageError}>
            <div className="contentMessage">
              <div>
                <p>{translate('error')}</p>
                <button
                  className="btn btn-primary"
                  onClick={this.props.hideMessageModal}
                >
                  {translate('ok')}
                </button>
              </div>
            </div>
          </div>
        )
      });

      this.props.handleRequest && this.props.handleRequest();
    }

    if (!isMessageModalOpen && contactUs.loaded && this.props.isMessageModalOpen) {
      this.props.reset();
      browserHistory.push(appendLocale(this.props.locale, '/'));
    }

    if (Object.keys(stateModifier).length) {
      this.setState(stateModifier);
    }
  }

  realtorRegionOptions = ['center', 'north', 'south', 'Jerusalem'];

  submitForm = (values) => {
      const { name, email, phone_number, message, realtor_region, company_name } = values;
      const { captcha } = this.state;
      const params = {
        name,
        captcha,
        realtor_region: realtor_region && realtor_region.toString(),
        email: email && email.toLowerCase(),
        phone: phone_number,
        company_name,
        message,
        locale: this.props.locale,
        ...(this.props.userData && this.props.userData.id) ? { user_id: this.props.userData.id } : {}
      };
      this.setState({ params });

      if (captcha) {
        this.props.sendContactUsForm({
          data: params,
          isRealtor: true
        });
      }
  };

  fetchReCaptchaToken = (token) => {
    this.setState({ captcha: token });
  }

  handleShowCaptcha = () => {
    this.setState({ showCaptcha: true });
  }

  handleSubmit = (evt) => {
    this.props.handleSubmit(this.submitForm)(evt);
    return true;
  };

  renderOption = (item) => ({
    id: item,
    label: `${this.props.translate('contactUsPage', 'userDetailsSection', item)}`
  });

  renderTextArea = ({ input, placeholder }) => (
    <OMTextArea
      placeholder={placeholder}
      {...input}
    />
  );

  renderCheckbox = ({ input }) => (
    <OMMultiCheckbox
      options={this.realtorRegionOptions.map(this.renderOption)}
      {...input}
    />
  );

  render() {
    const { translate, isPublishForm } = this.props;
    const contactUsTranslate = translate('contactUsPage', 'userDetailsSection');

    return (
      <div className={cx(styles.wrapper, { [styles.modal]: this.props.inModal })}>
        <div className={styles.titleWripper}>
          <p className={styles.title}>
            {contactUsTranslate(isPublishForm ? 'publishTitle' : 'title')}
          </p>
          <p>
            {contactUsTranslate(isPublishForm ? 'publishTitleInfo' : 'titleInfo')}
          </p>
        </div>
        <form onFocus={this.handleShowCaptcha} onSubmit={this.handleSubmit}>
          <div className={styles.infoBlock}>
            <div className={styles.columnInputs}>
              <div className={styles.inputWrapper}>
                <Field
                  name="name"
                  component={InputField}
                  type="text"
                  validate={[required]}
                  placeholder={`${contactUsTranslate('nameTitle')} *`}
                  translateForError={translate('errorFieldMessages')}
                  isRtl={this.props.isRtl}
                />
              </div>
              <div className={styles.inputWrapper}>
                <Field
                  name="phone_number"
                  component={InputField}
                  type="text"
                  validate={[required]}
                  placeholder={`${contactUsTranslate('phoneTitle')} *`}
                  translateForError={translate('errorFieldMessages')}
                  isRtl={this.props.isRtl}
                />
              </div>
              <div className={styles.inputWrapper}>
                <Field
                  name="email"
                  component={InputField}
                  type="text"
                  placeholder={contactUsTranslate('emailTitle')}
                  translateForError={translate('errorFieldMessages')}
                  isRtl={this.props.isRtl}
                />
              </div>
            </div>
          </div>
          <div className={styles.additionalBlock}>
            <div className={styles.companyName}>
              <div className={styles.label}>
                <span>{contactUsTranslate('companyName')}</span>
              </div>
              <Field
                name="company_name"
                component={InputField}
                type="text"
                placeholder={contactUsTranslate('companyName')}
                translateForError={translate('errorFieldMessages')}
                isRtl={this.props.isRtl}
              />
            </div>
            {!isPublishForm &&
              <div className={styles.inputMessage}>
                <div className={styles.label}>{translate('contactUsPage', 'messageSection', 'messageTitle')}</div>
                <Field
                  name="message"
                  component={this.renderTextArea}
                  type="text"
                  placeholder={translate('contactUsPage', 'messageSection', 'messageTitle')}
                  translateForError={translate('errorFieldMessages')}
                  isRtl={this.props.isRtl}
                />
              </div>
            }
            {!isPublishForm &&
              <div className={cx(styles.checkboxWrapper, styles.checkBoxWrap)}>
                <div className={styles.label}>{contactUsTranslate('realtorRegion')}</div>
                <Field
                  name="realtor_region"
                  component={this.renderCheckbox}
                  translateForError={translate('errorFieldMessages')}
                  isRtl={this.props.isRtl}
                />
              </div>
            }
          </div>
          <div className={styles.submitWrapper}>
            <div className={styles.submitNotification}>
              <p>
                {this.props.translate('contactUsPage', 'messageSection', 'submitNotification')}
              </p>
            </div>
            <div className={styles.submitBlock}>
             {this.state.showCaptcha && (
                <CloudflareCaptcha
                  action={CAPTCHA_ACTIONS.CONTACT_US_REALTOR}
                  doReset={this.props.contactUs.loaded}
                  fetchToken={this.fetchReCaptchaToken}
                />)
              }
              <OMButtonWithPreloader
                showPreloader={this.state.sending}
                className="contactUsForm"
                innerText={this.props.translate('contactUsPage', 'messageSection', 'submitForDetails')}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

RealtorLandingContactFormComponent.propTypes = {
  inModal: PropTypes.bool,
  handleRequest: PropTypes.func,
  translate: PropTypes.func,
  reset: PropTypes.func,
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
  sendContactUsForm: PropTypes.func,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool,
  locale: PropTypes.string,
  userData: PropTypes.object,
  contactUs: PropTypes.object,
  isMessageModalOpen: PropTypes.bool,
  openMessageModal: PropTypes.func,
  hideMessageModal: PropTypes.func,
  isPublishForm: PropTypes.bool
};

export default RealtorLandingContactFormComponent;
